{
  "w": 7,
  "h": 6,
  "rows": [
    "..WWW..",
    "GGCCCGG",
    "YGKKKGY",
    "KWK.KWK",
    ".K...K.",
    "......."
  ],
  "legend": {
    "K": "C.BLACK",
    "G": "C.B_GREEN",
    "C": "C.B_CYAN",
    "W": "C.B_WHITE",
    "Y": "C.B_YELLOW"
  }
}
